<!-- 下单人 -->
<template>
  <BaseFormItem2
    class="orderman_id"
    :label="fields.label"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <!-- 未登录 -->
    <NotLogin v-if="!isLogin" :isError="isError" text="请登录获取下单人信息" />
    <template v-else>
      <!-- 没数据 -->
      <BaseEmpty 
        v-if="options.length === 0"
        text="还没有下单人信息" 
        btnText="+新增一个" 
        :isError="isError"
        @btnClick="handleAdd" 
      />
      <div v-else class="orderman_id__content">
        <RadioTable2
          v-model="val"
          radioKey="id"
          radioLabel="#"
          :height="200"
          :showExpand="true"
          :isError="isError"
          :loading="loading"
          :columns="columns"
          :tableData="options"
          @change="handleChange"
        >
          <template v-slot:isDefault="{ row }">
            <span v-if="row.isDefault == 1" class="orderman_id__isDefault">
              默认
            </span>
          </template>
        </RadioTable2>

        <div class="orderman_id__add">
          <BaseTextButton :plain="false" :light="true" @click="handleAdd">
            <i class="el-icon-circle-plus-outline" />
            新增
          </BaseTextButton>
        </div>
      </div>
    </template>

    <!-- 新增下单人弹框 -->
    <AddOrderMan ref="addOrderManRef" @succ="handleChangeOrderMan"/>
  </BaseFormItem2>
</template>

<script>
// 未登录
import NotLogin from '@@/views/pcbQuote/components/notLogin'
// 单选表格
import RadioTable2 from '@@/components/radioTable/index2'
// 新增下单人
import AddOrderMan from '@@/views/stencil/components/addOrderMan'

import { isLogin } from '@@/utils/is'
import { getFR4Fields } from '@@/utils/getFields'
import { getOrderManPage } from '@@/api/customer'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    // 下单人
    orderman: {
      type: String,
      default: ''
    },
    // 下单人电话
    ordertel: {
      type: String,
      default: ''
    },
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NotLogin,
    RadioTable2,
    AddOrderMan
  },
  data() {
    return {
      loading: false,
      val: this.value,
      columns: [
        { label: '姓名', prop: 'orderMan', minWidth: 40 },
        { label: '手机/电话', prop: 'orderTel', minWidth: 60 },
        { label: '', prop: 'isDefault', slot: 'isDefault', minWidth: 20 }
      ],
      options: [],
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('orderman_id')
    },
    isLogin() {
      return isLogin()
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    // initPcbParamsChange(newVal) {
    //   if (this.isLogin && !newVal) {
    //     this.init()
    //   }
    // }
  },
  // mounted() {
  //   this.init()
  // },
  methods: {
    init() {
      if (!this.isLogin) return
      this.getList()
    },
    handleEmit() {
      this.$emit('input', this.val)
      this.isShowError(false)
    },
    handleChange(item) {
      const { id, orderMan, orderTel } = item || {}
      this.val = id
      this.handleEmit()
      this.$emit('update:orderman', orderMan)
      this.$emit('update:ordertel', orderTel)
      this.$emit('change', item || {})
    },
    getList() {
      this.loading = true
      getOrderManPage({ pageNum: 1, pageSize: 100 })
        .then(res => {
          if (!res) return
          const { suc, body = [], msg } = res
          if (suc) {
            this.options = body
            this.selectDefault()
          } else {
            this.$message.error(msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 当有已选时，选中已选的，否则选中第一个
    selectDefault() {
      const { val, options } = this
      if (options && options.length > 0) {
        const item = val && options.find(i => i.id == val)
        this.handleChange(item ? item : options[0])
      }
    },
    // 打开新增下单人弹框
    handleAdd() {
      this.$refs.addOrderManRef.open()
    },
    // 新增下单人
    handleChangeOrderMan(id) {
      this.val = id
      this.getList()
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.orderman_id {
  ::v-deep .base-form-item__content {
    width: calc(100% - 200px);
  }
  .orderman_id__isDefault {
    display: inline-block;
    width: 36px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: $--color-warning;
    text-align: center;
    border-radius: 2px;
    background-color: #FDF6EC;
  }
  .orderman_id__content {
    position: relative;
    .orderman_id__add {
      position: absolute;
      top: 0;
      right: -74px;
      &::before {
        content: '';
        position: absolute;
        left: -12px;
        top: 50%;
        display: block;
        width: 12px;
        height: 1px;
        background-color: #E1E1E1;
      }
    }
  }
  
}
</style>